import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ zone, account }) =>
    present(
      repository
        .getZoneRole(account, zone)
        .then((role) => ({ role, zone, account }))
        .catch(() => Promise.reject({ zone, account })),
    );
}

export type { Interactor };

export { createInteractor };
